export type ShipmentFormSavePolicy = {
  canEditMetadata: boolean;
  canEditRoute: boolean;
  canEditTracker: boolean;
};

export const CREATE_SAVE_POLICY: ShipmentFormSavePolicy = {
  canEditMetadata: true,
  canEditRoute: true,
  canEditTracker: true,
};

export function editSavePolicyFromCapabilities(input: {
  canEditMetadata: boolean;
  canEditRoute: boolean;
  canEditTracker: boolean;
}): ShipmentFormSavePolicy {
  return {
    canEditMetadata: input.canEditMetadata,
    canEditRoute: input.canEditRoute,
    canEditTracker: input.canEditTracker,
  };
}
